import React from "react";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import Container from "../../components/Container/Container";
import ModuleForm from "../../components/Module/ModuleForm";
import { API, ROUTER } from "../../constants/env";
const AddModule = () => {
  const { register, handleSubmit, errors, reset, control } = useForm();

  const onSubmit = (data) => {
    fetch(API.module.create, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error fel Srv", response.message, "error");
        }

        return swal("Good job!", "Module ajoutée", "success");
      })
      .catch((e) => {
        return swal("Error fel request", e.message, "error");
      });
  };

  return (
    <Container
      name="Ajouter un Module"
      back={true}
      backRoute={ROUTER.MODULES.LIST}
      submit={true}
    >
      <ModuleForm
        registerRequired={register({ required: true })}
        register={register}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        reset={reset}
        control={control}
      />
    </Container>
  );
};

export default AddModule;
